export default "__VITE_ASSET__CHFaC3wg__"